import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class PolicyProtocolMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.policyProtocol.policyProtocolMapperError"));

        Object.setPrototypeOf(this, PolicyProtocolMapperError.prototype);
    }
}